/**
 * Prende in ingresso una stringa in base64 e restituisce un oggetto Blob.
 * In caso di dataURI, è necessario rimuovere il prefisso `data:` prima di
 * chiamare questa funzione.
 */
export function base64ToByteArray(base64Data: string, sliceSize = 512) {
  const byteCharacters = atob(base64Data);

  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return byteArray;
}
